<template>
  <div class="landing-container-fixed">
    <header class="modern-header">
      <div class="header-content">
        <img
          width="200"
          class="logo-image"
          @click="$router.push('/')"
          alt="Good Casper logo"
          :src="require(`../assets/images/logo/good_casper_white.svg`)"
        />
        <div class="buttons-header">
          <v-btn text to="/faq" class="nav-btn">
            FAQ
          </v-btn>
          <v-btn
            text
            to="/Login?state=login"
            class="nav-btn"
          >
            Login
          </v-btn>
          <v-btn
            class="nav-btn"
            text
            to="/Login?state=signup"
          >
            Sign Up
          </v-btn>
          <v-btn
            to="/demo/Profile"
            class="nav-btn"
            text
          >
            Demo
          </v-btn>
        </div>
      </div>
    </header>
    <div class="content">
      <div class="hero-text-container">
        <h1 class="hero-title">
          Digital Memorials for
          <span class="gradient-text">Loved Ones</span> and
          <span class="gradient-text">Pets</span>
        </h1>
        <h2 class="hero-subtitle">
          Preserve memories, honor legacies, and keep their story alive
        </h2>
        <div class="cta-buttons">
          <v-btn
            large
            class="primary-btn"
            to="/Login?state=signup"
          >
            Create Memorial
          </v-btn>
          <v-btn
            large
            outlined
            class="secondary-btn"
            to="/demo/Profile"
          >
            View Demo
          </v-btn>
        </div>
        <div class="social-networks-container">
          <h4>#goodcasper</h4>
          <div class="social-icons">
            <a href="https://www.instagram.com/__good_casper__/" target="_blank">
              <img
                src="../assets/images/social-networks/instagram.svg"
                alt="Follow Good Casper on Instagram"
              />
            </a>
            <a href="https://www.tiktok.com/@good_casper" target="_blank">
              <img
                src="../assets/images/social-networks/tiktok.svg"
                alt="Follow Good Casper on TikTok"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="section h-1-5">
        <div class="circle-container d-flex justify-center align-center">
          <h1
            class="d-flex justify-center align-center text-center flex-column"
          >
            Good Casper <br />
            <span>Digital Memorial Platform</span>
          </h1>
          <v-avatar
            v-for="(avatar, index) in avatars"
            :key="index"
            class="avatar-image"
            width="100"
            height="100"
          >
            <v-img
              alt="Avatar of a person"
              :lazy-src="require('../assets/images/lazy-loading.png')"
              :src="avatar"
            ></v-img>
          </v-avatar>
        </div>
      </div>
      <div class="section pt-8">
        <v-row>
          <v-col cols="12" md="6">
            <v-img
              alt="A gravestone with a QR code that links to a Good Casper digital memorial"
              :lazy-src="require('../assets/images/lazy-loading.png')"
              src="../assets/images/landing/grave-qr-summer-1.png"
              class="mx-auto left-side-image"
              :aspect-ratio="16/9"
              transition="fade-transition"
              eager
            ></v-img>
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-center">
            <div class="after-circle-text">
              <p class="after-circle-text-title">Store and share</p>
              <p class="after-circle-text-title">all your</p>
              <p class="after-circle-text-title extra">memories</p>
              <p class="after-circle-text-title">in one place</p>
              <h2>One <span class="extra">scan</span> away from connection</h2>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <manual-steps />
    <div class="map-bg d-flex justify-center align-center">
      <div class="d-flex justify-center">
        <v-btn
          to="/demo/Profile"
          class="mx-auto landing-form mb-2 demo-button"
          outlined
        >
          Visit Good Casper Demo Profile
        </v-btn>
      </div>
    </div>
    <div
      class="section-full"
      :style="{ 'background-image': 'url(' + imageUrl + ')' }"
    >
      <v-row no-gutters>
        <v-col cols="4" md="2" class="d-flex links-container">
          <ul>
            <li
              :class="{ selected: selectedIndex == 0 }"
              @click="setSelectedLink(0)"
            >
              About Us
            </li>
            <li
              :class="{ selected: selectedIndex == 1 }"
              @click="setSelectedLink(1)"
            >
              Profile
            </li>
            <li
              :class="{ selected: selectedIndex == 2 }"
              @click="setSelectedLink(2)"
            >
              Timeline
            </li>
            <li
              :class="{ selected: selectedIndex == 3 }"
              @click="setSelectedLink(3)"
            >
              Last Greetings
            </li>
            <li
              :class="{ selected: selectedIndex == 4 }"
              @click="setSelectedLink(4)"
            >
              Images
            </li>
            <li
              :class="{ selected: selectedIndex == 5 }"
              @click="setSelectedLink(5)"
            >
              Videos
            </li>
            <li
              :class="{ selected: selectedIndex == 6 }"
              @click="setSelectedLink(6)"
            >
              Documents
            </li>
            <li
              :class="{ selected: selectedIndex == 7 }"
              @click="setSelectedLink(7)"
            >
              Missing Puzzle
            </li>
          </ul>
        </v-col>
        <v-col cols="8" md-10 class="links--images-container">
          <div
            v-if="selectedIndex == 0"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">About Us</p>
            <h2 class="third-text">
              Preserve Your Loved One's Legacy with a Digital Memorial
            </h2>
            <h3>
              Good Casper helps you <span class="bold-white">cherish</span> and
              <span class="bold-white">share memories</span> of
              <span class="bold-white">loved ones and pets</span> through
              <span class="bold-white">personalized digital tributes</span>.
            </h3>
            <img
              :src="linkImage"
              alt="About Us"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
          <div
            v-if="selectedIndex == 1"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">Profile</p>
            <h2>
              With features to share
              <span class="bold-white"
                >photos, videos, documents, and personal stories</span
              >, we help families and friends come together to celebrate lives
              and preserve legacies for future generations.
            </h2>
            <h3 class="third-text">Keep Their Story Alive</h3>
            <img
              :src="linkImage"
              alt="Good Casper profile"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
          <div
            v-if="selectedIndex == 2"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">Timeline</p>
            <h2>
              The <span class="bold-white">Timeline</span> feature allows you to
              capture the most significant moments of your loved one's life,
              from birth to their final days.<br />Every
              <span class="bold-white"
                >milestone, memory, and special event is preserved</span
              >, offering a beautiful and comprehensive tribute to their
              <span class="bold-white">life's story</span>.
            </h2>
            <h3 class="third-text">A Journey Through Life</h3>
            <img
              :src="linkImage"
              alt="Good Casper timeline"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
          <div
            v-if="selectedIndex == 3"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">Last Greetings</p>
            <h2 class="third-text">Words That Echo Through Time</h2>
            <h3>
              With <span class="bold-white">Last Greetings</span>, leave a
              lasting message of
              <span class="bold-white">love, gratitude, or farewell</span
              >.<br />These final words offer a sense of closure and remain a
              timeless tribute, creating a lasting bond that endures
              <span class="bold-white">beyond life</span>.
            </h3>
            <img
              :src="linkImage"
              alt="Good Casper last greetings"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
          <div
            v-if="selectedIndex == 4"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">Images</p>
            <h2>
              The <span class="bold-white">Images</span> feature allows you to
              upload and share cherished photos that
              <span class="bold-white">highlight the special moments</span> of a
              loved one's life.<br />Each image becomes a treasured memory,
              preserving their story and keeping their
              <span class="bold-white">legacy alive</span> for generations to
              come.
            </h2>
            <h3 class="third-text">Photos That Speak, Memories That Last</h3>
            <img
              :src="linkImage"
              alt="Good Casper images"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
          <div
            v-if="selectedIndex == 5"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">Videos</p>
            <h2>
              The <span class="bold-white">Videos</span> feature allows you to
              upload and share video tributes that capture the essence of your
              loved one's life.<br />From heartfelt messages to memorable
              events, each video preserves their
              <span class="bold-white">unique story</span> and creates a lasting
              connection, allowing you to
              <span class="bold-white">relive those special moments</span>
              anytime.
            </h2>
            <h3 class="third-text">Moments in Motion, Memories in Heart</h3>
            <img
              :src="linkImage"
              alt="Good Casper videos"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
          <div
            v-if="selectedIndex == 6"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">Documents</p>
            <h2 class="third-text">Documents That Tell Their Story</h2>
            <h3>
              The <span class="bold-white">Documents</span> feature allows you
              to upload and store important
              <span class="bold-white"
                >papers, letters, and written memories</span
              >.<br />From heartfelt notes to official records, each document
              helps preserve the story of your loved one, ensuring their legacy
              is captured in
              <span class="bold-white">both words and memories</span>.
            </h3>
            <img
              :src="linkImage"
              alt="Good Casper documents"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
          <div
            v-if="selectedIndex == 7"
            class="link-image"
            :class="{ ['image' + selectedIndex]: true }"
          >
            <p class="my-title">Missing Puzzle</p>
            <h2>
              Friends and family can share images you don't have, helping
              <span class="bold-white">complete</span> your loved one's story.
              Review and add these moments to your gallery,
              <span class="bold-white">piece by piece</span>.
            </h2>
            <h3 class="third-text">The Puzzle Isn't Complete Without You</h3>
            <img
              :src="linkImage"
              alt="Good Casper missing puzzle"
              :lazy-src="require('../assets/images/lazy-loading.png')"
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import helpers from "../plugins/helpers";
import ManualSteps from "../components/ManualSteps.vue";

export default {
  name: "Landing",
  data() {
    return {
      linkImage: "",
      linkImageMissing: "",
      imageUrl: "",
      c: "",
      selectedIndex: 0,
      selectedIndexMissing: 0,
      observer: null,
      observerMap: null,
      avatars: [
        {
          src: require(`../assets/images/profiles/profile-man-1-min.jpg`),
        },
        {
          src: require(`../assets/images/profiles/profile-man-2-min.jpg`),
        },
        {
          src: require(`../assets/images/profiles/profile-man-3-min.jpg`),
        },
        {
          src: require(`../assets/images/profiles/profile-woman-11-min.jpg`),
        },
        {
          src: require(`../assets/images/profiles/profile-woman-4-min.jpg`),
        },
        {
          src: require(`../assets/images/profiles/profile-woman-5-min.jpg`),
        },
      ],
    };
  },
  components: {
    ManualSteps,
  },
  computed: {
    language: {
      get() {
        return localStorage.getItem("lang") || this.$store.state.lang;
      },
      set(value) {
        localStorage.setItem("lang", value);
        this.$store.state.lang = value;
      },
    },
    languages() {
      return helpers.languageDropdown();
    },
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    setSelectedLink(index) {
      var imageContainer = document.querySelector(".section-full");

      this.selectedIndex = index;
      imageContainer.style.opacity = 0;
      imageContainer.style.opacity = 1;

      this.imageUrl = require(`../assets/images/background/image${index}.jpg`);
      this.linkImage = require(`../assets/images/background/image${index}.jpg`);

      switch (index) {
        case 0:
          this.linkImage = require(`../assets/images/logo/good_casper_white.svg`);
          break;
        case 1:
          this.linkImage = require(`../assets/images/screenshots/profile.png`);
          break;
        case 2:
          this.linkImage = require(`../assets/images/screenshots/timeline.png`);
          break;
        case 3:
          this.linkImage = require(`../assets/images/screenshots/last_greetings.png`);
          break;
        case 4:
          this.linkImage = require(`../assets/images/screenshots/images.png`);
          break;
        case 5:
          this.linkImage = require(`../assets/images/screenshots/videos.png`);
          break;
        case 6:
          this.linkImage = require(`../assets/images/screenshots/documents.png`);
          break;
        default:
          this.linkImage = require(`../assets/images/screenshots/missing.png`);
          break;
      }
    },
    handleIntersection(entries, observer) {
      const afterCircleText = document.querySelector(".after-circle-text");
      const avatarImages = document.querySelectorAll(".avatar-image");
      const gcH1 = document.querySelector(".circle-container h1");
      const spans = document.querySelectorAll(".hero-text-container h3 span");
      const spansH2 = document.querySelectorAll(".hero-text-container h2 span");
      const h2 = document.querySelector(".hero-text-container h2");
      const leftSideImage = document.querySelector(".left-side-image");

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          spans.forEach((span) => {
            span.style.animation = "none";
          });
          spansH2.forEach((span) => {
            span.style.animation = "none";
          });
          h2.style.animation = "none";
          afterCircleText.style.animation = "none";
          leftSideImage.style.animation = "none";
          gcH1.style.animation = "fade-in 0.5s ease-in-out 1s forwards";
          avatarImages.forEach((avatarImage, index) => {
            avatarImage.style.animation = "fade-in 2.5s ease-in-out forwards";
            if (index == 0) {
              avatarImage.style.animation =
                "slide-in-top 1.5s ease-in-out forwards";
            } else if (index == 1) {
              avatarImage.style.animation = "slide-in 2s ease-in-out forwards";
            } else if (index == 2) {
              avatarImage.style.animation =
                "slide-in 1.75s ease-in-out forwards";
            } else if (index == 3) {
              avatarImage.style.animation =
                "slide-in-left 2s ease-in-out forwards";
            } else if (index == 4) {
              avatarImage.style.animation =
                "slide-in-left 2s ease-in-out forwards";
            } else if (index == 5) {
              avatarImage.style.animation =
                "slide-in-left 2.5s ease-in-out forwards";
            }
          });
        } else {
          spans.forEach((span) => {
            span.style.animation = "slide-in 1.5s ease-in-out forwards";
          });
          spansH2.forEach((span) => {
            span.style.animation = "slide-in 1.5s ease-in-out forwards";
          });
          avatarImages.forEach((avatarImage, index) => {
            avatarImage.style.animation = "fade-out 0.5s ease-in-out forwards";
          });

          afterCircleText.style.animation = "fade-in 2s ease-in-out forwards";
          leftSideImage.style.animation =
            "slide-in-from-left 0.8s ease-in-out forwards";

          h2.style.animation = "fade-in 3s ease-in-out forwards";
          gcH1.style.animation = "none";
        }
      });
    },
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  mounted() {
    document.title = "Good Casper - Landing";
    this.$store.dispatch("user/logout");

    const avatarImages = document.querySelectorAll(".avatar-image");

    avatarImages.forEach((avatarImage, index) => {
      var bodyWithLessThen600px = window.matchMedia("(max-width: 600px)");
      if (index == 0) {
        if (bodyWithLessThen600px.matches) {
          avatarImage.style.top = "-150px";
          avatarImage.style.left = "-50px";
        } else {
          avatarImage.style.top = "-120px";
          avatarImage.style.left = "-200px";
        }
      } else if (index == 1) {
        if (bodyWithLessThen600px.matches) {
          avatarImage.style.bottom = "-70px";
          avatarImage.style.right = "-50px";
        } else {
          avatarImage.style.bottom = "-85px";
          avatarImage.style.right = "-200px";
        }
      } else if (index == 2) {
        if (bodyWithLessThen600px.matches) {
          avatarImage.style.bottom = "-150px";
          avatarImage.style.left = "-20px";
        } else {
          avatarImage.style.bottom = "-150px";
          avatarImage.style.left = "-200px";
        }
      } else if (index == 3) {
        if (bodyWithLessThen600px.matches) {
          avatarImage.style.bottom = "160px";
          avatarImage.style.right = "-100px";
        } else {
          avatarImage.style.bottom = "-150px";
          avatarImage.style.right = "-400px";
        }
      } else if (index == 4) {
        if (bodyWithLessThen600px.matches) {
          avatarImage.style.bottom = "0px";
          avatarImage.style.left = "-100px";
        } else {
          avatarImage.style.bottom = "-75px";
          avatarImage.style.left = "-400px";
        }
      } else if (index == 5) {
        if (bodyWithLessThen600px.matches) {
          avatarImage.style.top = "-220px";
          avatarImage.style.lft = "-120px";
        } else {
          avatarImage.style.top = "-120px";
          avatarImage.style.right = "-200px";
        }
      }
    });

    this.observer = new IntersectionObserver(this.handleIntersection);

    const target = document.querySelector(".circle-container");

    if (target) {
      this.observer.observe(target);
    }

    window.addEventListener("beforeunload", () => {
      if (this.observer) {
        this.observer.disconnect();
      }
    });

    this.setSelectedLink(0);

    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", "#000");

    document.documentElement.classList.add("landing");
  },
  destroyed() {
    document.documentElement.classList.remove("landing");
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;900&display=swap');

.modern-header {
  position: relative;
  z-index: 1000;
  background: transparent;
  padding: 0.5rem 2rem;
  transition: all 0.3s ease;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
  }

  .logo-image {
    transition: transform 0.3s ease;
    &:hover {
      transform: scale(1.05);
    }
  }

  .buttons-header {
    display: flex;
    gap: 1.5rem;
    align-items: center;

    .nav-btn {
      color: rgba(255, 255, 255, 0.9) !important;
      font-family: 'Montserrat', sans-serif !important;
      font-weight: 500 !important;
      font-size: 0.95rem !important;
      letter-spacing: 0.3px !important;
      text-transform: none !important;
      padding: 0.5rem 1.25rem !important;
      border-radius: 8px !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      position: relative !important;
      overflow: hidden !important;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.1);
        transform: translateX(-100%);
        transition: transform 0.3s ease;
      }
      
      &:hover {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.08) !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
        
        &::before {
          transform: translateX(0);
        }
      }

      &:active {
        transform: translateY(0) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
      }
    }
  }
}

@media (max-width: 768px) {
  .modern-header {
    padding: 0.75rem 1rem;
    
    .header-content {
      flex-direction: column;
      gap: 1rem;
    }

    .logo-image {
      width: 150px;
    }

    .buttons-header {
      width: 100%;
      justify-content: center;
      flex-wrap: wrap;
      gap: 0.75rem;
      
      .nav-btn {
        font-size: 0.85rem !important;
        padding: 0.4rem 0.75rem !important;
        min-width: auto !important;
      }
    }
  }
}

.landing-container-fixed {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
  min-height: 100vh;
  font-family: 'Montserrat', sans-serif !important;
}


.manual-steps {
  .gradient-text {
      color: rgba(255, 255, 255, 0.85);
  }
}

.hero-text-container {
  padding-top: 0px;
  text-align: center;
  margin: 0 auto;
  width: 100%;
  max-width: 95%;

  .hero-title {
    font-family: 'Montserrat', sans-serif !important;
    font-size: clamp(3.7rem, 6.1vw, 4.8rem) !important;
    font-weight: 900 !important;
    line-height: 1.1 !important;
    letter-spacing: -0.02em !important;
    margin-bottom: 1.5rem !important;
    opacity: 0;
    animation: fade-in 1s ease-out forwards;
    white-space: normal;
    width: 100%;
    text-align: center;

    .gradient-text {
      background: linear-gradient(45deg, #FF6B6B, #4ECDC4) !important;
      -webkit-background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      background-clip: text !important;
      font-weight: 900 !important;
      display: inline !important;
      transform: scale(1.05) !important;
    }
  }

  .hero-subtitle {
    font-family: 'Montserrat', sans-serif !important;
    font-size: clamp(1.4rem, 2.2vw, 1.7rem) !important;
    color: rgba(255, 255, 255, 0.85) !important;
    line-height: 1.5 !important;
    font-weight: 400 !important;
    margin: 0 auto 2.5rem auto !important;
    opacity: 0;
    animation: fade-in 1s ease-out 0.5s forwards;
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
    letter-spacing: 0.01em !important;
    text-align: center;
  }

  .cta-buttons {
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    margin-bottom: 4rem;
    opacity: 0;
    animation: fade-in 1s ease-out 1s forwards;

    .primary-btn {
      background: linear-gradient(45deg, #FF6B6B, #4ECDC4) !important;
      color: white !important;
      font-weight: 600;
      font-size: 1.125rem;
      padding: 0 2.5rem;
      height: 52px;
      border-radius: 26px;
      text-transform: none;
      letter-spacing: 0.5px;
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
      }
    }

    .secondary-btn {
      border: 2px solid rgba(255, 255, 255, 0.2) !important;
      color: white !important;
      font-weight: 600;
      font-size: 1.125rem;
      padding: 0 2.5rem;
      height: 52px;
      border-radius: 26px;
      text-transform: none;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.1) !important;
        transform: translateY(-2px);
      }
    }
  }
}

.social-networks-container {
  margin-top: 2rem;
  margin-bottom: 0;
  opacity: 0;
  animation: fade-in 1s ease-out 1.5s forwards;
  padding: 1.5rem 2rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  gap: 1.5rem;

  h4 {
    font-family: 'Montserrat', sans-serif !important;
    font-size: 1.4rem;
    font-weight: 600 !important;
    background: linear-gradient(45deg, #FF6B6B, #4ECDC4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0;
    letter-spacing: 0.5px;
    line-height: 1;
  }

  .social-icons {
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      padding: 0.6rem;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      line-height: 0;
      
      &:hover {
        transform: translateY(-3px);
        background: rgba(255, 255, 255, 0.1);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
      }

      img {
        width: 35px;
        height: 35px;
        opacity: 0.9;
        transition: all 0.3s ease;
        filter: brightness(0.9);
        display: block;

        &:hover {
          opacity: 1;
          filter: brightness(1);
        }
      }
    }
  }

  @media (max-width: 600px) {
    margin-top: 1.5rem;
    padding: 1rem 1.5rem;
    gap: 1.25rem;
    
    h4 {
      font-size: 1.2rem;
    }

    .social-icons {
      gap: 1.25rem;
      
      a {
        padding: 0.5rem;
        
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .modern-header {
    padding: 1rem;
    
    .logo-image {
      width: 150px;
    }
  }

  .content {
    padding: 0 0rem;
  }

  .hero-text-container {
    max-width: 100%;
    padding: 4rem 1rem 0 1rem;
    
    .hero-title {
      font-size: clamp(2.2rem, 3.5vw, 2.8rem) !important;
      margin-bottom: 1.25rem !important;
      white-space: normal;
    }

    .hero-subtitle {
      font-size: clamp(1.2rem, 2vw, 1.4rem) !important;
      margin-bottom: 2rem !important;
      max-width: 80%;
    }

    .cta-buttons {
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      
      .primary-btn,
      .secondary-btn {
        width: 100%;
        max-width: 300px;
        font-size: 1rem;
        height: 48px;
      }
    }
  }
}

.demo-button {
  position: relative;
  z-index: 1;
  width: 500px;
  height: 80px !important;
  background: rgba(255, 255, 255, 0.08) !important;
  color: white !important;
  font-weight: 600 !important;
  font-size: 1.25rem !important;
  padding: 0 2.5rem !important;
  border-radius: 40px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  overflow: hidden !important;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
    transform: translateX(-100%);
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    transform: translateY(-3px) !important;
    background: rgba(255, 255, 255, 0.12) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3) !important;
    
    &::before {
      transform: translateX(0);
    }
  }

  &:active {
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
  }

  .v-btn__content {
    color: white !important;
    font-family: 'Montserrat', sans-serif !important;
    position: relative;
    z-index: 1;
  }
  
  @media (max-width: 600px) {
    width: 90% !important;
    height: 60px !important;
    font-size: 1rem !important;
    padding: 0 1.5rem !important;
    border-radius: 30px !important;
  }
}

.buttons-header {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-right: 15px;
  @media (max-width: 600px) {
    flex: 1 0 100%;
    margin-right: 0;
    justify-content: center;
  }
}

.landing-container-fixed header {
  @media (max-width: 600px) {
    padding-right: 0 !important;
  }
}

.section.h-1-5 {
  h1 {
    font-size: 22px;
    span {
      font-size: 18px;
    }
  }
}

.social-networks-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 90px;
  img {
    cursor: pointer;
  }
  @media (max-width: 600px) {
    margin-top: 80px;
    gap: 10px;
    h1 {
      font-size: 22px;
    }
  }
}

.logo-image {
  @media (max-width: 600px) {
    display: none;
  }
}

.map-bg {
  position: relative;
  background-attachment: fixed;
  background-image: url("../assets/images/landing/network-6.jpg");
  background-position: center;
  background-size: cover;
  height: 100vh;
  border-image: fill 0 linear-gradient(to top, #00000000, #212121b4);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .demo-button {
    position: relative;
    z-index: 1;
    width: 500px;
    height: 80px !important;
    background: rgba(255, 255, 255, 0.08) !important;
    color: white !important;
    font-weight: 600 !important;
    font-size: 1.25rem !important;
    padding: 0 2.5rem !important;
    border-radius: 40px !important;
    text-transform: none !important;
    letter-spacing: 0.5px !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    overflow: hidden !important;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(45deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
      transform: translateX(-100%);
      transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:hover {
      transform: translateY(-3px) !important;
      background: rgba(255, 255, 255, 0.12) !important;
      border-color: rgba(255, 255, 255, 0.2) !important;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3) !important;
      
      &::before {
        transform: translateX(0);
      }
    }

    &:active {
      transform: translateY(-1px) !important;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
    }

    .v-btn__content {
      color: white !important;
      font-family: 'Montserrat', sans-serif !important;
      position: relative;
      z-index: 1;
    }
    
    @media (max-width: 600px) {
      width: 90% !important;
      height: 60px !important;
      font-size: 1rem !important;
      padding: 0 1.5rem !important;
      border-radius: 30px !important;
    }
  }

  @media screen and (max-width: 600px) {
    display: none;
  }
}

html.landing * {
  &::-webkit-scrollbar {
    width: 7px;
    background: rgb(3, 3, 3) !important;
  }

  &::-webkit-scrollbar-thumb {
    background: #252525 !important;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slide-in-from-left {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slide-in-bottom {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slide-out-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

@keyframes slide-in-left {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slide-in-right {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

.lang-select {
  border-radius: 4px;
  width: 140px;
  * {
    color: #e0e0e0 !important;
  }
}

.landing-container-fixed {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url("../assets/images/landing/black-smooth-textured-paper-background.jpg");
  background-size: cover;
  background-position: center;
  overflow-y: auto;
  color: #e0e0e0;
  .section {
    height: 100vh;
    color: #e0e0e0;
    position: relative;
    &.h-1-5 {
      height: 100vh;
      @media screen and (max-width: 600px) {
        h1 {
          font-size: 20px;
          span {
            font-size: 16px;
          }
        }
      }
    }
    .circle-container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 200px;
      height: 200px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.178);
      @media screen and (max-width: 600px) {
        width: 150px;
        height: 150px;
      }
      .avatar-image {
        position: absolute;
        @media screen and (max-width: 600px) {
          width: 60px !important;
          height: 60px !important;
        }
      }
      h1 {
        font-family: 'Montserrat', sans-serif !important;
        font-size: 24px !important;
        font-weight: 700 !important;
        color: rgba(255, 255, 255, 0.95) !important;
        text-align: center !important;
        line-height: 1.4 !important;
        margin: 0 !important;
        padding: 0 15px !important;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
        opacity: 0;
        animation: fade-in 0.5s ease-in-out 1s forwards;
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        width: 100% !important;
        
        span {
          display: block !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          color: rgba(255, 255, 255, 0.8) !important;
          margin-top: 8px !important;
        }
        
        @media screen and (max-width: 600px) {
          font-size: 18px !important;
          line-height: 1.3 !important;
          padding: 0 10px !important;
          width: 100% !important;
          
          span {
            font-size: 14px !important;
            margin-top: 4px !important;
            line-height: 1.2 !important;
          }
        }
      }
    }
    .after-circle-text {
      opacity: 0;
      text-align: left;
      padding-left: 40px;
      @media screen and (max-width: 600px) {
        text-align: center;
        padding-left: 0;
      }
      .extra {
        color: #e0e0e0;
      }
      .after-circle-text-title {
        font-size: 55px;
        line-height: 50px;
        text-transform: uppercase;
        font-weight: 800;
        color: #747474;
        @media screen and (max-width: 600px) {
          font-size: 28px;
          line-height: 30px;
        }
      }
      h2 {
        font-size: 28px;
        line-height: 38px;
        text-transform: uppercase;
        font-weight: 500;
        margin-top: 40px;
        color: #767676;
        @media screen and (max-width: 600px) {
          font-size: 20px;
          line-height: 30px;
        }
      }
    }
    .left-side-image {
      opacity: 0;
      border-radius: 12px;
    }
  }
  @media (max-width: 600px) {
    padding-top: 0;
    header {
      padding-right: 10px;
    }
  }
}

.landing-form {
  border: 1px solid #e0e0e0;
  * {
    color: #e0e0e0;
  }
}

.content {
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
  @media screen and (max-width: 600px) {
    width: 95%;
  }
  .hero-text-container {
    margin-top: 120px;
    min-height: calc(100vh - 200px);
    text-align: center;
    @media (max-width: 600px) {
      margin-top: 20px;
      text-align: center;
    }
    h1 {
      font-size: 35px;
      font-weight: 700;
      margin-bottom: 40px;
      opacity: 0;
      animation: fade-in 3.5s ease-in-out forwards;
      @media (max-width: 600px) {
        font-size: 28px;
      }
    }
    h2 {
      font-size: 30px;
      font-weight: 400;
      line-height: 1.5;
      color: #747474;
      span {
        display: inline-block;
        color: #e0e0e0;
      }
      @media (max-width: 600px) {
        font-size: 22px;
      }
    }
    h3 {
      font-size: 30px;
      font-weight: 400;
      line-height: 1.5;
      color: #747474;
      span {
        display: inline-block;
        color: #e0e0e0;
      }
      @media (max-width: 600px) {
        font-size: 22px;
      }
    }
    h4 {
      font-size: 28px;
      font-weight: 400;
      line-height: 1.5;
      color: #e0e0e0;
      @media (max-width: 600px) {
        font-size: 20px;
      }
    }
  }
}

.logo-image {
  animation: slide-in-top 1s ease-in-out 0.5s forwards;
}

.section-full {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/images/background/image3.jpg");
  background-position: center;
  background-size: cover;
  opacity: 0;
  transition: opacity 3s ease;
  border-image: fill 0 linear-gradient(to left, #0000009b, #000000a5);
  overflow: hidden;
  .links-container {
    height: 100vh;
    align-items: center;
  }
  ul {
    margin-left: 20px;
    padding-left: 0;
    list-style: none;
    @media screen and (max-width: 600px) {
      margin-left: 10px;
    }
    li {
      user-select: none;
      cursor: pointer;
      background: black;
      background: hsl(0deg 0% 73% / 20%);
      color: #e0e0e0;
      border: 1px solid transparent;
      margin: 10px 0;
      padding: 2px 10px;
      border-radius: 30px;
      width: fit-content;
      backdrop-filter: blur(14px);
      transition: border-color 0.3s, background-color 0.3s;

      @media screen and (max-width: 600px) {
        font-size: 14px;
        border-radius: 8px;
        width: 100%;
      }
      &.selected {
        color: #fff;
        border: 1px solid #fff;
        background: transparent;
      }
    }
  }
  .link-image {
    @media screen and (max-width: 600px) {
      padding-right: 10px;
    }
    img {
      width: 35%;
      border-radius: 12px;
      animation: slide-in-bottom 0.5s ease-in forwards;
      position: absolute;
    }
    .my-title {
      font-size: 60px;
      font-weight: 500;
      position: absolute;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
      @media screen and (max-width: 600px) {
        display: none;
      }
    }
    h3,
    h2 {
      max-width: 400px;
      line-height: 30px;
      font-size: 20px;
      font-weight: 500;
      position: absolute;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
      @media screen and (max-width: 600px) {
        font-size: 16px;
      }
    }
    .third-text {
      font-size: 20px;
      font-weight: 700;
      color: #fff;

      @media screen and (max-width: 600px) {
        font-size: 18px;
      }
    }
    .bold-white {
      font-weight: 700;
      color: #fff;
    }
    &.image0,
    &.image3,
    &.image6,
    &.image9 {
      .my-title {
        bottom: 250px;
        left: 0;
        animation: slide-in-right 0.5s ease-in forwards;
      }
      h2 {
        bottom: 100px;
        left: 10%;
        animation: slide-in-left 0.5s ease-in forwards;
        @media screen and (max-width: 600px) {
          left: 0px;
        }
      }
      h3 {
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        animation: slide-in-left 0.5s ease-in forwards;
        @media screen and (max-width: 600px) {
          left: 10px;
        }
      }
      img {
        bottom: 30px;
        right: 30px;
        width: 400px !important;
        @media screen and (max-width: 1336px) {
          display: none;
        }
      }
    }
    &.image1,
    &.image4,
    &.image7,
    &.image10 {
      .my-title {
        bottom: 100px;
        left: 10%;
        transform: translateX(-50%);
        animation: slide-in-left 0.5s ease-in forwards;
      }
      h3 {
        bottom: 100px;
        right: 100px;
        animation: slide-in-bottom 0.5s ease-in forwards;
        @media screen and (max-width: 600px) {
          right: 10px;
        }
      }
      h2 {
        top: 100px;
        left: 100px;
        animation: slide-in-top 0.5s ease-in forwards;
        @media screen and (max-width: 600px) {
          left: 10px;
        }
      }
      img {
        top: 100px;
        right: 100px;
        width: 330px !important;
        animation: slide-in-right 0.5s ease-in forwards;

        @media screen and (max-width: 1336px) {
          display: none;
        }
      }
    }
    &.image2,
    &.image5,
    &.image8,
    &.image11 {
      .my-title {
        bottom: 250px;
        right: 200px;
        animation: slide-in-right 0.5s ease-in forwards;
      }
      h2 {
        top: 100px;
        left: 100px;
        animation: slide-in-right 0.5s ease-in forwards;
        @media screen and (max-width: 600px) {
          left: 10px;
        }
      }
      h3 {
        bottom: 100px;
        left: 50%;
        animation: slide-in-bottom 0.5s ease-in forwards;
        @media screen and (max-width: 600px) {
          left: 10px;
        }
      }
      img {
        bottom: 50px;
        left: 50px;
        width: 500px !important;
        animation: slide-in-left 0.5s ease-in forwards;

        @media screen and (max-width: 1336px) {
          display: none;
        }
      }
    }
    &.image0 {
      img {
        width: 450px !important;
        bottom: 180px;
      }
    }
    &.image1 {
      img {
        right: 0;
        border-radius: 4px;
      }
    }
    &.image2 {
      img {
        bottom: 30px;
        left: 50px;
        width: 280px !important;
        border-radius: 4px;
      }
    }
    &.image3 {
      img {
        bottom: 30px;
        right: 30px;
        width: 320px !important;
        border-radius: 4px;
      }
    }
    &.image4 {
      img {
        top: 250px;
        right: 0px;
        width: 420px !important;
        border-radius: 0;
      }
    }
    &.image5 {
      img {
        bottom: 170px;
        width: 500px !important;
        border-radius: 0;
      }
    }
    &.image6 {
      img {
        bottom: 170px;
        right: -100px;
        width: 600px !important;
        border-radius: 4px;
      }
    }
    &.image7 {
      img {
        right: 0;
        top: 300px;
        width: 600px !important;
        border-radius: 4px;
      }
      h3 {
        bottom: 50px;
      }
    }
  }
  .links--images-container {
    position: relative;
  }
}

.section-full-missing {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/images/background/image3.jpg");
  background-position: center;
  background-size: cover;
  opacity: 0;
  transition: opacity 3s ease;
  border-image: fill 0 linear-gradient(to left, #0000009b, #000000a5);
  overflow: hidden;
  .links-container {
    height: 100vh;
    align-items: center;
  }
  ul {
    margin-left: 20px;
    padding-left: 0;
    list-style: none;
    li {
      user-select: none;
      cursor: pointer;
      background: black;
      background: hsl(0deg 0% 73% / 20%);
      color: #e0e0e0;
      border: 1px solid transparent;
      margin: 10px 0;
      padding: 2px 10px;
      border-radius: 30px;
      width: fit-content;
      backdrop-filter: blur(14px);
      transition: border-color 0.3s, background-color 0.3s;
      &.selected {
        color: #fff;
        border: 1px solid #fff;
        background: transparent;
      }
    }
  }
  .link-image {
    img {
      width: 35%;
      border-radius: 12px;
      animation: slide-in-bottom 0.5s ease-in forwards;
      position: absolute;
    }
    .my-title {
      font-size: 88px;
      font-weight: 500;
      position: absolute;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    }
    h3,
    h2 {
      max-width: 200px;
      line-height: 20px;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    }
    &.image0,
    &.image3,
    &.image6,
    &.image9 {
      h1 {
        bottom: 250px;
        left: 0;
        animation: slide-in-right 0.5s ease-in forwards;
      }
      h2 {
        bottom: 100px;
        left: 30%;
        animation: slide-in-left 0.5s ease-in forwards;
      }
      h3 {
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        animation: slide-in-left 0.5s ease-in forwards;
      }
      img {
        bottom: 30px;
        right: 30px;
        width: 500px !important;
      }
    }
    &.image1,
    &.image4,
    &.image7,
    &.image10 {
      h1 {
        bottom: 100px;
        left: 30%;
        transform: translateX(-50%);
        animation: slide-in-left 0.5s ease-in forwards;
      }
      h3 {
        bottom: 100px;
        right: 100px;
        animation: slide-in-bottom 0.5s ease-in forwards;
      }
      h2 {
        top: 100px;
        left: 100px;
        animation: slide-in-top 0.5s ease-in forwards;
      }
      img {
        top: 100px;
        right: 100px;
        width: 400px !important;
        animation: slide-in-right 0.5s ease-in forwards;
      }
    }
    &.image2,
    &.image5,
    &.image8,
    &.image11 {
      h1 {
        bottom: 250px;
        right: 200px;
        animation: slide-in-right 0.5s ease-in forwards;
      }
      h2 {
        top: 100px;
        left: 100px;
        animation: slide-in-right 0.5s ease-in forwards;
      }
      h3 {
        bottom: 100px;
        left: 50%;
        animation: slide-in-bottom 0.5s ease-in forwards;
      }
      img {
        bottom: 50px;
        left: 50px;
        width: 400px !important;
        animation: slide-in-left 0.5s ease-in forwards;
      }
    }
  }
  .links--images-container {
    position: relative;
  }
}

// Remove inheritance and set direct styles
.landing-container-fixed .content .hero-text-container h1.hero-title,
.landing-container-fixed .content h1.hero-title,
.hero-text-container h1.hero-title {
  font-family: 'Montserrat', sans-serif !important;
  font-weight: 900 !important;
  line-height: 1.1 !important;
  margin: 0 auto 1.5rem auto !important;
  color: rgba(255, 255, 255, 0.95) !important;
  letter-spacing: -0.02em !important;
  text-transform: none !important;
  width: 100%;
  text-align: center;
}

.landing-container-fixed .content .hero-text-container h2.hero-subtitle,
.landing-container-fixed .content h2.hero-subtitle,
.hero-text-container h2.hero-subtitle {
  font-family: 'Montserrat', sans-serif !important;
  font-size: clamp(1.6rem, 2.4vw, 1.9rem) !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  margin: 0 auto 2.5rem auto !important;
  letter-spacing: 0.01em !important;
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.85) !important;
}

@media (max-width: 768px) {
  .landing-container-fixed .content .hero-text-container h1.hero-title,
  .landing-container-fixed .content h1.hero-title,
  .hero-text-container h1.hero-title {
    font-size: clamp(2.2rem, 3.85vw, 2.475rem) !important;
    margin-bottom: 1.25rem !important;
  }

  .landing-container-fixed .content .hero-text-container h2.hero-subtitle,
  .landing-container-fixed .content h2.hero-subtitle,
  .hero-text-container h2.hero-subtitle {
    font-size: clamp(1.2rem, 2vw, 1.4rem) !important;
    margin-bottom: 2rem !important;
    max-width: 95%;
  }
}

.hero-title {
  padding-top: 30px;
}

.buttons-header {
  margin-top: 0!important;
}

.section.pt-8 {
  padding-top: 4rem;
  position: relative;
  overflow: hidden;
  
  .v-img {
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
    }
  }
  
  .after-circle-text {
    opacity: 0;
    text-align: left;
    padding-left: 40px;
    animation: fade-in 1s ease-out 0.5s forwards;
    
    @media screen and (max-width: 600px) {
      text-align: center;
      padding-left: 0;
      margin-top: 2rem;
    }
    
    .extra {
      color: #e0e0e0;
      background: linear-gradient(45deg, #FF6B6B, #4ECDC4);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-weight: 800;
    }
    
    .after-circle-text-title {
      font-size: clamp(2.5rem, 4vw, 3.5rem);
      line-height: 1.1;
      text-transform: uppercase;
      font-weight: 800;
      color: #747474;
      margin: 0;
      letter-spacing: -0.02em;
      
      @media screen and (max-width: 600px) {
        font-size: clamp(1.8rem, 3vw, 2.2rem);
        line-height: 1.2;
      }
    }
    
    h2 {
      font-size: clamp(1.5rem, 2.5vw, 2rem);
      line-height: 1.4;
      text-transform: uppercase;
      font-weight: 500;
      margin-top: 2rem;
      color: #767676;
      letter-spacing: 0.02em;
      
      @media screen and (max-width: 600px) {
        font-size: clamp(1.2rem, 2vw, 1.5rem);
        margin-top: 1.5rem;
      }
      
      .extra {
        font-weight: 700;
        color: #e0e0e0;
      }
    }
  }
}
</style>